<template>
 <div class="custom-dialog" :style="{left: $vuetify.application.left+'px'}">
    <div class="custom-dialog-container">
      <div class="custom-dialog-closer"></div>
      <v-container fluid>
        <v-row>
          <v-col>
            <!-- <o-progress v-if="loading"/> -->
            <pop-up-layout :saving="saving" :title="titulo" :description="pregunta" :loading="loading" :ocultarVolver="true">
              <v-layout column justify-center align-center>
                <v-img
                  style="margin-bottom: 30px; width:180px;"
                  :src="require('@/assets/images/WARNING_GRIS.png')"
                />
                <o-description-title v-if="consecuencia">
                  {{consecuencia}}
                </o-description-title>
                <o-description-title v-if="alerta">
                  {{alerta}}
                </o-description-title>
              </v-layout>
              <v-layout wrap justify-center align-center slot="acciones">
                <v-btn
                  class="mx-3"
                  color="primary"
                  @click="$emit('aceptar',false)"
                  :disabled="saving || loading"
                >
                  {{cancelar}}
                </v-btn>
                <v-btn
                  class="mx-3"
                  color="primary"
                  @click="$emit('aceptar',true, idioma)"
                  :disabled="saving || loading"
                  :loading="saving"
                >
                  {{descartar}}
                </v-btn>
                <v-btn
                  v-show="mostrarVolver"
                  class="mx-3"
                  color="error"
                  @click="$emit('volver',false)"
                  :disabled="saving || loading"
                >
                  {{volver}}
                </v-btn>
                <v-col
                  v-if="esResumen"
                  class="d-flex"
                  cols="12"
                  sm="3"
                >
                <v-select
                  v-model="idioma" 
                  id="idioma"
                  :items="idiomas"
                  item-text="descIdioma"
                  item-value="codIdioma"
                  :label="$t('idiomaDeEnvio')"
                  width="50"
                ></v-select>
                </v-col>
                
              </v-layout>
            </pop-up-layout>
          </v-col>
        </v-row>
      </v-container>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      titulo: {
        type: String,
        default () {
          return this.$t('message.popUps.popUpSeguro.titulo')
        }
      },
      pregunta: {
        type: String,
        default () {
          return this.$t('message.popUps.popUpSeguro.pregunta')
        }
      },
      consecuencia: {
        type: String,
        default: ''
      },
      alerta: {
        type: String,
        default () {
          return this.$t('message.popUps.popUpSeguro.alerta')
        }
      },
      descartar: {
        type: String,
        default () {
          return this.$t('message.popUps.popUpSeguro.descartar')
        }
      },
      cancelar: {
        type: String,
        default () {
          return this.$t('message.popUps.popUpSeguro.cancelar')
        }
      },
      volver: {
        type: String,
        default () {
          return this.$t('message.popUps.popUpSeguro.volver')
        }
      },
      saving: {
        type: Boolean,
        default: false
      },
      loading: {
        type: Boolean,
        default: false
      },
      disabled: {
        type: Boolean,
        default: false
      },
      mostrarVolver: {
        type: Boolean,
        default:false
      },
      esResumen: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        idiomas: [
          {
            codIdioma: 'spa',
            descIdioma: this.$t('popUpTranslate.espanol'),
          },
          {
            codIdioma: 'eng',
            descIdioma: this.$t('popUpTranslate.ingles'),
          },
          {
            codIdioma: 'eus',
            descIdioma: this.$t('popUpTranslate.euskera'),
          },          
        ],
        idioma: null
      }
    },
    computed: {
      usuario() {
        return JSON.parse(localStorage.getItem('usuario'))
      },  
    },
    created () {
      // this.idioma = this.idiomas.find(item => item.codIdioma == this.usuario.idioma)
      this.idioma = this.usuario.idioma
    },
  }
</script>

<style lang="sass" scoped>
  .custom-dialog
    position: fixed
    top: 0
    bottom: 0
    right: 0
    left: 0
    z-index: 6
    overflow-y: scroll
    transition-property: transform, width, -webkit-transform
    transition: 0.2s cubic-bezier(0.4, 0, 0.2, 1)

  .custom-dialog-container
    position: relative
    min-height: 100%
    width: 100%
    display: flex
    align-content: center

  .custom-dialog-closer
    position: absolute
    top: 0
    bottom: 0
    left: 0
    right: 0
    background-color: rgba(0,0,0,.8)
    &:hover
      cursor: pointer

</style>
